// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowThinLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="9" viewBox="0 0 4 9" fill="currentColor">
            <path
                fill="#666"
                d="M715.030748,1042.00289 C714.883771,1042.16012 714.646607,1042.15705 714.500591,1042.02989 L711.001841,1038.97555 L707.502623,1042.03016 C707.348076,1042.16373 707.111451,1042.152 706.972466,1042.00316 C706.834654,1041.85288 706.847076,1041.62333 707.000826,1041.48924 L710.729732,1038.21645 C710.873287,1038.09215 711.08856,1038.09215 711.232232,1038.21645 L714.961139,1041.48924 C715.15731,1041.62333 715.169028,1041.85288 715.030747,1042.00289 L715.030748,1042.00289 Z"
                transform="matrix(0 1 1 0 -1038.123 -706.877)"
            />
        </svg>
    );
};

export default React.memo(IconArrowThinLeft);
